export default __webpack_public_path__ + "static/media/decada-2000-0010-min.f7af0108.jpeg";